<ion-content class="ion-padding">
  <div class="inbox-layout-manager-content">
    <!-- Sort Options -->
    <div class="section">
      <h3 class="section-title">Sort by</h3>
      <ion-button
        fill="clear"
        color="dark"
        (click)="showSortOptions($event)"
        class="btn-small no-margin button-dark-border"
      >
        <span class="text-with-right-icon">{{ getCurrentSortLabel() }}</span>
        <ion-icon name="chevron-down" class="button-icon"></ion-icon>
      </ion-button>
    </div>

    <!-- Layout Options -->
    <div class="section">
      <h3 class="section-title">Layout</h3>
      <div class="pill-tab-container">
        <div
          class="round-pill-tab"
          [ngClass]="{
            'round-pill-tab-active': currentLayout === 'grid'
          }"
          (click)="onLayoutChangeClick('grid')"
        >
          <ion-icon name="custom-kanban"></ion-icon>
          Kanban
        </div>
        <div
          class="round-pill-tab round-pill-tab-left"
          [ngClass]="{
            'round-pill-tab-active': currentLayout === 'table'
          }"
          (click)="onLayoutChangeClick('table')"
        >
          <ion-icon name="list"></ion-icon>
          Table
        </div>
        <div
          class="round-pill-tab"
          [ngClass]="{
            'round-pill-tab-active': currentLayout === 'sidebar'
          }"
          (click)="onLayoutChangeClick('sidebar')"
        >
          <ion-icon name="custom-sidebar"></ion-icon>
          Sidebar
        </div>
      </div>
    </div>

    <!-- Column Management - Only show for table layout -->
    <div class="section" *ngIf="currentLayout === 'table'">
      <h3 class="section-title">Column Management</h3>
      <p class="instructions">
        Hide, show, or rearrange columns in the table view:
      </p>
      <div
        class="columns-list"
        cdkDropList
        (cdkDropListDropped)="onDrop($event)"
      >
        <div
          *ngFor="let column of workingColumns"
          class="column-item"
          cdkDrag
          [cdkDragDisabled]="column.required"
        >
          <div class="column-content">
            <ion-icon
              name="custom-drag-vertical"
              class="drag-handle"
              [class.disabled]="column.required"
            ></ion-icon>

            <ion-checkbox
              [checked]="column.visible"
              [disabled]="column.required"
              (ionChange)="toggleColumn(column)"
              class="column-checkbox"
            ></ion-checkbox>

            <span class="column-name">{{ column.name }}</span>

            <ion-chip
              *ngIf="column.required"
              color="primary"
              class="required-chip"
            >
              Required
            </ion-chip>
          </div>
        </div>
      </div>
      <ion-button color="dark" (click)="save()" class="btn-xs">
        Save columns
      </ion-button>
      <ion-button color="dark" (click)="resetToDefault()" class="btn-xs">
        Reset to default
      </ion-button>
    </div>
  </div>
</ion-content>
